import { Observable, Subscription } from 'rxjs';

import { ModalService } from './../../../services/modal.service';
import {
  ProcessParticipation,
  KnownProcessType,
  ProcessRespondentSelectionCriterionType,
  ProcessRespondentSelectionCriterionValue,
} from './../../../models/process-models';
import { ConfigService } from './../../../services/config.service';
import { UserService } from './../../../services/user.service';
import { Component, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Respondent } from '../../../models/respondent.model';
import { BusinessUnitService } from '../../../services/business-unit.service';
import { NamedEntity } from '../../../models/named-entity.model';
import { EmployeeAdvancedSearchRequest } from '../../employee-selection/employee-advanced-search-request.model';
import { ProcessParticipationService } from '../../../services/process.participation.service';
import { AddRespondentsByBURequest } from '../../../models/process-models/add-respondents-by-bu-request.model';
import { NgxItem } from '../../../models/common.share.model';
import { EnumDescription } from '../../../helpers/enum-description.helper';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-add-respondent',
  templateUrl: './add-respondent.component.html',
  styleUrls: ['./add-respondent.component.scss'],
})
export class AddRespondentComponent implements OnInit, OnDestroy {
  isMultipleMode = false;
  isOnDraft = false;
  processDurationAppraiseeIds: Array<number>;
  processDurationAppraiseeId: number;
  appraiseeName;
  knownProcessTypes: Array<KnownProcessType>;
  set respondentSelectionValues(
    selectionValues: Array<ProcessRespondentSelectionCriterionValue>
  ) {
    this._360Types = selectionValues
      .map((v) => v.selectionType)
      .filter((t) => +t >= 2 && +t <= 6)
      .map(
        (t) =>
          ({
            id: +t,
            text: EnumDescription.GetDescription(
              ProcessRespondentSelectionCriterionType,
              +t
            ),
          } as NgxItem)
      );
  }

  businessUnits: Array<NamedEntity> = [];
  respondents: Array<NamedEntity> = [];
  selectedBusinessUnitId: number;
  selectedRespondentId: number;
  isOnSaving: boolean = false;
  isPMEChecked: boolean;
  isPMQChecked: boolean;
  isCombinedChecked: boolean;
  is360Checked: boolean;
  selected360Type: number;
  _360Types: Array<NgxItem>;
  processTypes = KnownProcessType;
  _respondentSelectionValues: Array<ProcessRespondentSelectionCriterionValue>;
  isAdded = false;
  addedRespondents: Array<Respondent>;
  subscription: Subscription;

  constructor(
    private modalRef: BsModalRef,
    private bsModalService: BsModalService,
    private userService: UserService,
    private appData: ConfigService,
    private modalService: ModalService,
    private businessUnitService: BusinessUnitService,
    private processParticipationService: ProcessParticipationService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.bsModalService.onHide.subscribe(() => {
      this.isOnSaving = false;
    });
    this.resetModalData();
    this.initComponent();
  }

  searchRespondentsByName(event: string) {
    if (event.length < this.appData.configData.minimumSearchStringLength) {
      return;
    }

    let searchRequest = {
      searchPattern: event,
    } as EmployeeAdvancedSearchRequest;
    if (this.selectedBusinessUnitId) {
      searchRequest.businessUnitIds = [this.selectedBusinessUnitId];
    }

    this.userService
      .getByAdvancedSearch(searchRequest)
      .subscribe((data: Array<NamedEntity>) => {
        this.respondents = data;
      });
  }

  openModal(template: TemplateRef<any>) {
    this.initComponent();
    this.modalRef = this.bsModalService.show(template);
  }

  clearBusinessUnit() {
    this.selectedBusinessUnitId = null;
  }

  clearSelectedRespondent() {
    this.selectedRespondentId = null;
  }

  selectBusinessUnit(event: number) {
    this.selectedBusinessUnitId = event;
  }

  selectPerson(event: number) {
    this.selectedRespondentId = event;
  }

  addRespondents() {
    if (this.isOnSaving || !this.isDataValid()) {
      this.raiseFormValidationErrorPopup();
      return;
    }
    this.isOnSaving = true;

    let result: Observable<Array<Respondent>>;
    if (this.selectedRespondentId) {
      result = this.addSingleRespondent();
    } else if (this.selectedBusinessUnitId) {
      result = this.addRespondentsByBU();
    } else {
      return;
    }

    this.subscription = result.subscribe((data: Array<Respondent>) => {
      this.addedRespondents = data;
      this.isAdded = true;
      this.modalRef.hide();
    });
  }

  private isDataValid(): boolean {
    return (
      this.isAnyProcessTypeSelected() && this.isAnyRespondentOrBUSelected()
    );
  }

  private raiseFormValidationErrorPopup() {
    if (!this.isAnyRespondentOrBUSelected()) {
      this.toastr.error(
        'No respondents or BUs selected',
        'Adding respondents failed'
      );
    } else if (!this.isAnyProcessTypeSelected()) {
      this.toastr.error(
        'No process type selected',
        'Adding respondents failed'
      );
    }
  }

  private isAnyProcessTypeSelected(): boolean {
    return (
      (this.isPMEChecked ||
        this.isPMQChecked ||
        this.isCombinedChecked ||
        (this.is360Checked && !!this.selected360Type)) &&
      (!this.is360Checked || !!this.selected360Type)
    );
  }
  private isAnyRespondentOrBUSelected(): boolean {
    return !!this.selectedBusinessUnitId || !!this.selectedRespondentId;
  }

  hideModal() {
    if (this.modalRef) {
      this.modalRef.hide();
    }
    this.resetModalData();
  }

  private addSingleRespondent(): Observable<Array<Respondent>> {
    if (this.isMultipleMode) {
      let requests = this.processDurationAppraiseeIds.map((id) =>
        this.сreateParticipation(id)
      );
      return this.processParticipationService.addMultiple(
        requests,
        !this.isOnDraft
      );
    }
    return this.processParticipationService.add(
      this.сreateParticipation(this.processDurationAppraiseeId),
      !this.isOnDraft
    );
  }

  private сreateParticipation(processDurationAppraiseeId: number) {
    return {
      processDurationAppraiseeId: processDurationAppraiseeId,
      respondents: [
        {
          id: this.selectedRespondentId,
          selectedProcessParticipationSelectionCriterionType: this.getSelectedCriterionType(),
          knownProcessTypes: this.getSelectedKnownProcessTypes(),
        } as Respondent,
      ],
    } as ProcessParticipation;
  }

  private addRespondentsByBU(): Observable<Array<Respondent>> {
    if (this.isMultipleMode) {
      let requests = this.processDurationAppraiseeIds.map((id) =>
        this.CreateAddRespondentsByBURequest(id)
      );
      return this.processParticipationService.addByBUMultiple(
        requests,
        !this.isOnDraft
      );
    }
    return this.processParticipationService.addByBU(
      this.CreateAddRespondentsByBURequest(this.processDurationAppraiseeId),
      !this.isOnDraft
    );
  }

  private CreateAddRespondentsByBURequest(
    processDurationAppraiseeId: number
  ): AddRespondentsByBURequest {
    return {
      processDurationAppraiseeId: processDurationAppraiseeId,
      businessUnitId: this.selectedBusinessUnitId,
      criterionType: this.getSelectedCriterionType(),
      knownProcessTypes: this.getSelectedKnownProcessTypes(),
    } as AddRespondentsByBURequest;
  }

  private getSelectedCriterionType(): number {
    return this.is360Checked ? this.selected360Type : 0;
  }

  private getSelectedKnownProcessTypes(): Array<KnownProcessType> {
    let result = [] as Array<KnownProcessType>;

    if (this.isPMEChecked) {
      result.push(KnownProcessType.PME);
    }
    if (this.isPMQChecked) {
      result.push(KnownProcessType.PMQ);
    }
    if (this.isCombinedChecked) {
      result.push(KnownProcessType.Combined);
    }
    if (this.is360Checked) {
      result.push(KnownProcessType._360);
    }

    return result;
  }

  private initComponent() {
    this.hideModalSubscriber();
    this.businessUnitService.getAll().subscribe((x) => {
      x.sort((a, b) => a.name.localeCompare(b.name));
      this.businessUnits = x;
    });
  }

  private resetModalData() {
    this.clearBusinessUnit();
    this.clearSelectedRespondent();
    this.respondents = [];
    this.isPMEChecked = false;
    this.isPMQChecked = false;
    this.isCombinedChecked = false;
    this.is360Checked = false;
  }

  private hideModalSubscriber() {
    this.modalService.hideModal$.subscribe((x) => this.hideModal());
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
